import classNames from 'classnames';

import { Divider } from '@testsigma/atoms';

import { ConnectionFormBody } from '@modules/salesforce/shared/components/connection-form/connection-form-body';

import { ConnectionFormHeader } from './header/connection-form-header';
import { ViewDetailsFormActions } from './footer/view-details';

import { useViewConnectionForm, useViewConnection } from '../../../hooks';

const UserConnectionDetailsForm: React.FC = () => {
  const { watch, values } = useViewConnectionForm();
  const { handleClose, handleDelete, handleEdit } = useViewConnection();

  return (
    <form>
      <div>
        <ConnectionFormHeader />
      </div>

      <Divider type='solid' />

      <div>
        <fieldset
          disabled={false}
          className={classNames('pointer-events-none')}>
          <ConnectionFormBody watch={watch} values={values} />
        </fieldset>
      </div>

      <Divider type='solid' />

      <footer>
        <ViewDetailsFormActions
          handleClose={handleClose}
          handleEdit={handleEdit}
          handleDelete={handleDelete}
        />
      </footer>
    </form>
  );
};

export { UserConnectionDetailsForm };
